function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'fuchsia-pink': 'rgb(244, 75, 211)','buttercup-brown': 'rgb(230, 145, 76)','fresh-blue': 'rgb(0, 91, 211)','emerald': 'rgb(28, 137, 79)','rose-red': 'rgb(236, 10, 91)','light-red': 'rgb(246, 31, 31)','marine': 'rgb(38, 78, 20)','silk': 'rgb(233, 226, 191)','burgundy': 'rgb(167, 19, 19)','blue-grey': 'rgb(169, 174, 180)','nude': 'rgb(234, 222, 192)','caramel': 'rgb(217, 192, 158)','dark-pink': 'rgb(255, 0, 137)','deep-brown': 'rgb(121, 68, 39)','eucalyptus-green': 'rgb(61, 150, 91)','lotus-lily-pink': 'rgb(233, 86, 178)','bush-apple-red': 'rgb(200, 8, 21)','monsoon-blue': 'rgb(4, 3, 72)','brolga-red': 'rgb(255, 8, 0)','barramundi-silver': 'rgb(219, 219, 220)','coconut-white': 'rgb(253, 255, 245)','cycad-green': 'rgb(76, 196, 23)','outback-orange': 'rgb(226, 88, 34)','pipe-clay-beige': 'rgb(245, 245, 220)','pandanus-purple': 'rgb(63, 1, 44)','billabong-green': 'rgb(74, 93, 35)','gouldian-purple': 'rgb(145, 74, 168)','hibiscus-pink': 'rgb(217, 1, 102)','mindil-blue': 'rgb(194, 209, 255)','sunset-red': 'rgb(255, 64, 64)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
